import { passThroughAxios } from './passThrough.axios'

export default {
  getDealerSettings() {
    return passThroughAxios.get('dealer-settings')
  },
  updateDealerSettings(payload) {
    return passThroughAxios.put('dealer-settings', payload)
  },
  // CST-4237: Admin dealer settings management
  getAllDealerSettings() {
    return passThroughAxios.get('dealer-settings/all')
  },
}
